import { Pipe, PipeTransform, Injectable } from '@angular/core'

@Pipe({
  name: 'stringReplace',
})
@Injectable()

/* Custom pipe to replace all occurrences of a value within a string with another value
Example usage; {{myString | stringReplace:'_':' '}} 
*/
export class StringReplace implements PipeTransform {
  transform(input, from, to) {
    input = input || ''
    from = from || ''
    to = to || ''
    return input.replace(new RegExp(from, 'g'), to)
  }
}
